<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <h5 class="content-header-title float-left pr-1 mb-0">{{ user.name }}</h5>
            <div class="breadcrumb-wrapper col-12">
              <ol class="breadcrumb p-0 mb-0">
                <li class="breadcrumb-item">
                  <router-link :to="{name: 'DashboardPage' }">
                    <em class="bx bx-home-alt"></em>
                  </router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{name: backUrl.url }">{{ backUrl.name }}</router-link>
                </li>
                <li class="breadcrumb-item active">{{ user.name }}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-body">
      <section class="page-user-profile">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-content">
                <div class="user-profile-images">
                  <!-- user timeline image -->
                  <img
                    src="@/app-assets/images/profile/post-media/profile-banner.jpg"
                    class="img-fluid rounded-top user-timeline-image"
                    alt="user timeline image"
                  />
                  <!-- user profile image -->
                  <div class="user-avatar user-profile-image rounded">
                    <span class="avatar-name" v-if="avatar">{{ avatar.toUpperCase() }}</span>
                  </div>
                </div>
                <div class="user-profile-text">
                  <h4 class="mb-0 text-bold-500 text-primary capitalize">{{ user.name }}</h4>
                  <small class="text-primary capitalize">{{ user.type }} - {{ user.uid }}</small>
                </div>
                <!-- user profile nav tabs start -->
                <div class="card-body px-0">
                  <ul
                    class="nav user-profile-nav justify-content-center justify-content-md-start nav-tabs border-bottom-0 mb-0"
                    role="tablist"
                  >
                    <li class="nav-item pb-0">
                      <a
                        class="nav-link d-flex px-1 active"
                        id="details-tab"
                        data-toggle="tab"
                        href="#details"
                        aria-controls="details"
                        role="tab"
                        aria-selected="false"
                      >
                        <span class="d-none d-md-block">Details</span>
                      </a>
                    </li>
                    <li class="nav-item pb-0">
                      <a
                        class="nav-link d-flex px-1"
                        id="houses-tab"
                        data-toggle="tab"
                        href="#houses"
                        aria-controls="houses"
                        role="tab"
                        aria-selected="true"
                      >
                        <span class="d-none d-md-block">Properties</span>
                      </a>
                    </li>
                    <li class="nav-item pb-0">
                      <a
                        class="nav-link d-flex px-1"
                        id="proposals-tab"
                        data-toggle="tab"
                        href="#proposals"
                        aria-controls="proposals"
                        role="tab"
                        aria-selected="false"
                      >
                        <span class="d-none d-md-block">Proposals</span>
                      </a>
                    </li>
                    <li class="nav-item pb-0">
                      <a
                        class="nav-link d-flex px-1"
                        id="contracts-tab"
                        data-toggle="tab"
                        href="#contracts"
                        aria-controls="contracts"
                        role="tab"
                        aria-selected="false"
                      >
                        <span class="d-none d-md-block">Contracts</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="tab-content">
                  <!-- Details Tab -->
                  <div class="tab-pane active" id="details" aria-labelledby="details-tab" role="tabpanel">
                    <UserDetailsComponent :user="user" v-if="user.uid"/>
                  </div>

                  <!-- Houses Tab -->
                  <div
                    class="tab-pane"
                    id="houses"
                    aria-labelledby="houses-tab"
                    role="tabpanel"
                  >
                    <div class="card">
                      <div class="card-content">
                        <div class="card-body">
                          <div class="text-center">
                            <div
                              class="spinner-border text-primary"
                              role="status"
                              v-if="loadingDataHouses"
                              style="opacity: .6"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                          <p
                            class="text-center mb-0"
                            v-if="!properties.length && !loadingDataHouses"
                          >No Properties Found...</p>
                          <div class="table-responsive" v-if="properties.length">
                            <table class="table houses-table nowrap scroll-horizontal" :aria-label="$t('users_aria_label_single_user_properties_list')">
                              <thead>
                                <tr>
                                  <th>House Name</th>
                                  <th>Status</th>
                                  <th>Country</th>
                                  <th>City</th>
                                  <th>Address</th>
                                  <th>Last Edited At</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(house, index) in properties" :key="index">
                                  <td v-if="house.name" class="houseName">
                                    <span>{{ house.name }}</span>
                                    <br />
                                    <small>Created: {{ house.createdAt.split('T')[0] }}</small>
                                    <br />
                                    <a
                                      style="margin-top: 5px;"
                                      @click="onHouseEditClick(house.uid)" 
                                    >
                                      <em class="bx bx-edit-alt"></em> Edit
                                    </a>
                                  </td>
                                  <td class="capitalize">
                                    <span v-if="house.status == 'approved'">
                                      <em class="bx bxs-circle success font-small-1 mr-50"></em>
                                      {{ house.status }}
                                    </span>
                                    <span v-if="house.status == 'preapproved'">
                                      <em class="bx bxs-circle warning font-small-1 mr-50"></em>
                                      {{ house.status }}
                                    </span>
                                    <span v-if="house.status == 'banned'">
                                      <em class="bx bxs-circle danger font-small-1 mr-50"></em>
                                      {{ house.status }}
                                    </span>
                                    <span
                                      v-if="house.status == 'rejected_by_admin' || house.status == 'rejected_by_landlord'"
                                    >
                                      <em class="bx bxs-circle danger font-small-1 mr-50"></em>
                                      {{ house.status.replaceAll("_", " ") }}
                                    </span>
                                    <span
                                      v-if="house.status == 'needs_approval_by_landlord' || house.status == 'needs_approval_by_admin'"
                                    >
                                      <em class="bx bxs-circle info font-small-1 mr-50"></em>
                                      {{ house.status.replaceAll("_", " ") }}
                                    </span>
                                    <span
                                      v-if="house.status == 'draft_by_admin' || house.status == 'draft_by_landlord'"
                                    >
                                      <em class="bx bxs-circle default font-small-1 mr-50"></em>
                                      {{ house.status.replaceAll("_", " ") }}
                                    </span>
                                  </td>
                                  <td v-if="house.country">{{ countryName(house.country) }}</td>
                                  <td v-else>-</td>
                                  <td v-if="house.address">{{ house.address.city }}</td>
                                  <td v-else>-</td>
                                  <td v-if="house.address">
                                    <span
                                      v-if="house.address.street"
                                    >{{ house.address.street }}, {{ house.address.city }}</span>
                                    <span v-else>-</span>
                                    <br />
                                    <span v-if="house.address.zip">{{ house.address.zip }}</span>
                                    <span v-else>-</span>
                                  </td>
                                  <td v-else>-</td>
                                  <td>{{ house.lastEditedAt.split('T')[0] }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Proposals Tab -->
                  <div
                    class="tab-pane"
                    id="proposals"
                    aria-labelledby="proposals-tab"
                    role="tabpanel"
                  >
                    <div class="card">
                      <div class="card-content">
                        <div class="card-body">
                          <div class="text-center">
                            <div
                              class="spinner-border text-primary"
                              role="status"
                              v-if="loadingDataProposals"
                              style="opacity: .6"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                          <p
                            class="text-center mb-0"
                            v-if="!proposals.length && !loadingDataProposals"
                          >No Proposals Found...</p>
                          <div class="table-responsive" v-if="proposals.length">
                            <table class="table proposals-table" :aria-label="$t('users_arial_label_single_user_contracts')">
                              <thead>
                                <tr>
                                  <th>Contract Name</th>
                                  <th>Creation Status</th>
                                  <th>Negotiation Status</th>
                                  <th>Country</th>
                                  <th>Created At</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(proposal, index) in proposals" :key="index">
                                  <td class="templateName capitalize">
                                    <span v-if="proposal.property.address">
                                      {{ proposal.property.address.street }}, {{ countryName(proposal.country) }} 
                                    </span>
                                    <span v-else>-</span>
                                    <br />
                                    <a
                                      @click="viewProposalDetails(proposal.id)"
                                      style="margin-top: 5px;" 
                                    >View Details</a>
                                  </td>
                                  <td class="capitalize">
                                    <span v-if="proposal.creationStatus == 'draft_by_admin'">
                                      <em class="bx bxs-circle default font-small-1 mr-50"></em>
                                      {{ proposal.creationStatus.replaceAll("_", " ") }}
                                    </span>
                                    <span v-if="proposal.creationStatus == 'draft_by_landlord'">
                                      <em class="bx bxs-circle default font-small-1 mr-50"></em>
                                      {{ proposal.creationStatus.replaceAll("_", " ") }}
                                    </span>
                                    <span
                                      v-if="proposal.creationStatus == 'needs_approval_by_admin'"
                                    >
                                      <em class="bx bxs-circle info font-small-1 mr-50"></em>
                                      {{ proposal.creationStatus.replaceAll("_", " ") }}
                                    </span>
                                    <span
                                      v-if="proposal.creationStatus == 'needs_approval_by_landlord'"
                                    >
                                      <em class="bx bxs-circle info font-small-1 mr-50"></em>
                                      {{ proposal.creationStatus.replaceAll("_", " ") }}
                                    </span>
                                    <span v-if="proposal.creationStatus == 'approved'">
                                      <em class="bx bxs-circle success font-small-1 mr-50"></em>
                                      {{ proposal.creationStatus }}
                                    </span>
                                    <span v-if="proposal.creationStatus == 'archived'">
                                      <em class="bx bxs-circle warning font-small-1 mr-50"></em>
                                      {{ proposal.creationStatus }}
                                    </span>
                                  </td>
                                  <td class="capitalize">
                                    <span v-if="!proposal.negotiationStatus">-</span>
                                    <span
                                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'accepted_by_landlord'"
                                    >
                                      <em class="bx bxs-circle success font-small-1 mr-50"></em>
                                      {{ proposal.negotiationStatus.replaceAll("_", " ") }}
                                    </span>
                                    <span
                                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'accepted_by_all'"
                                    >
                                      <em class="bx bxs-circle success font-small-1 mr-50"></em>
                                      {{ proposal.negotiationStatus.replaceAll("_", " ") }}
                                    </span>
                                    <span
                                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'declined_by_tenant'"
                                    >
                                      <em class="bx bxs-circle danger font-small-1 mr-50"></em>
                                      {{ proposal.negotiationStatus.replaceAll("_", " ") }}
                                    </span>
                                    <span
                                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'change_requested_by_tenant'"
                                    >
                                      <em class="bx bxs-circle info font-small-1 mr-50"></em>
                                      {{ proposal.negotiationStatus.replaceAll("_", " ") }}
                                    </span>
                                    <span
                                      v-if="proposal.negotiationStatus && proposal.negotiationStatus == 'archived'"
                                    >
                                      <em class="bx bxs-circle warning font-small-1 mr-50"></em>
                                      {{ proposal.negotiationStatus }}
                                    </span>
                                  </td>
                                  <td>{{ countryName(proposal.country) }}</td>
                                  <td>{{ proposal.createdAt.split('T')[0] }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Contracts Tab -->
                  <div class="tab-pane" id="contracts" aria-labelledby="contracts-tab" role="tabpanel">
                    <UserContractsComponent :contracts="user.contracts" v-if="user.uid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import { getCountryName } from "@/app-assets/js/get-countries.js";
import Alert from "@/components/Alerts";
import UserDetailsComponent from "@/views/Users/components/UserDetailsComponent";
import UserContractsComponent from "@/views/Users/components/UserContractsComponent";
export default {
  data() {
    return {
      loadingDataHouses: true,
      loadingDataProposals: true,
      user: {},
      backUrl: {},
      userUUID: this.$route.params.uuid,
      properties: [],
      proposals: [],
    };
  },

  components: {
    UserDetailsComponent,
    UserContractsComponent
  },

  computed: {
    avatar() {
      let user = this.user;
      if (user.name) {
        let name = user.name.split(" ")[0];
        let surname = user.name.split(" ")[1];
        if (surname) {
          return name[0] + surname[0];
        } else {
          if (name[1]) {
            return name[0] + name[1];
          } else {
            return name[0];
          }
        }
      }
    },
  },

  methods: {
    viewProposalDetails(proposalId){
      window.open(`/contracts/proposals/${proposalId}`, '_blank');
    },
    onHouseEditClick(houseId){
      window.open(`/houses/${houseId}`, '_blank');
    },
    getUser() {
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall
        .get(`/v1/users/${this.userUUID}`)
        .then((response) => {
          this.user = response.data;

          if (this.user.properties) {
            this.getHouse(this.user.properties);
          } else {
            this.loadingDataHouses = false;
          }

          if (this.user.contractProposals) {
            this.getProposals(this.user.contractProposals);
          } else {
            this.loadingDataProposals = false;
          }

          if(!this.user.contracts) {
            this.user.contracts = [];
          }

          if (this.user.type == "tenant") {
            this.backUrl = {
              url: "TenantsPage",
              name: "Tenants",
            };
          } else if (this.user.type == "landlord") {
            this.backUrl = {
              url: "LandlordsPage",
              name: "Landlords",
            };
          }
          $.unblockUI();
        })
        .catch((error) => {
          console.log(error);
          $.unblockUI();
        });
    },

    getHouse(uuidList) {
      this.loadingDataHouses = true;
      let url = [];
      uuidList.forEach((uuid) => {
        url.push(this.$apiCall.get(`/v1/properties/${uuid}`));
      });

      Promise.all(url)
        .then((response) => {
          response.forEach((x) => {
            this.properties.push(x.data);
          });
          this.loadingDataHouses = false;
          this.initDataTableHouses();
        })
        .catch((error) => {
          this.loadingDataHouses = false;
          console.log(error);
        });
    },

    getProposals(uuidList) {
      this.loadingDataProposals = true;
      let url = [];
      uuidList.map((uuid) => {
        url.push(this.$apiCall.get(`/v1/contracts/proposals/${uuid}`));
      });

      Promise.all(url)
        .then((response) => {
          response.forEach((x) => {
            this.proposals.push(x.data);
          });
          this.loadingDataProposals = false;
          this.initDataTableProposals();
        })
        .catch((error) => {
          this.loadingDataProposals = false;
          console.log(error);
        });
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    initDataTableHouses() {
      let self = this;
      setTimeout(function () {
        $(".houses-table").DataTable({
          bLengthChange: false,
          bFilter: false,
          order: [],
        });
      }, 100);
    },

    initDataTableProposals() {
      let self = this;
      setTimeout(function () {
        $(".proposals-table").DataTable({
          bLengthChange: false,
          bFilter: false,
          order: [],
        });
      }, 100);
    },
  },

  mounted() {
    this.getUser();
  },
};
</script>

<style scoped>
.user-avatar {
  background: #ff8302;
  width: 140px;
  height: 140px;
  color: #fff;
  position: relative;
}

.avatar-name {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 80px;
  letter-spacing: 1px;
}
a:not([href]):not([tabindex]) {
    color: #5A8DEE !important;
    text-decoration: none !important;
    cursor: pointer;
}
</style>